import axios from 'axios';
import VueGallery from 'vue-gallery';

export default {
    components: {
        gallery: VueGallery,
    },
    data() {
        return {
            imagePath: 'https://show.guyanalive.com',
            images: [],
            title: '',
            errors: [],
            index: null,
            page: 1,
            maxReached: false,
        };
    },
    // Fetches posts when the component is created.
    created() {
        window.scrollTo(0, 0);
        this.getAlbum(`${this.$route.params.category}/${this.$route.params.album}`);
    },
    methods: {
        getAlbum(path) {
            axios
                .get(
                    `https://show.guyanalive.com/index.php?album=${
                        path
                    }&json&page=${
                        this.page}`,
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.images = response.data.album.images;
                    if (this.images) {
                        this.images.map((image) => {
                            image.href = this.imagePath + image.url_full;
                            return image;
                        });
                        this.title = response.data.album.title;
                        // adjust max flag based on return number
                        this.maxReached = false;
                        if (this.images.length < 20) {
                            this.maxReached = true;
                        }
                    }
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        goNext() {
            this.page = this.page + 1;
            if (!this.maxReached) {
                this.images = [];
                this.getAlbum(
                    `${this.$route.params.category}/${this.$route.params.album}`,
                );
                document.getElementById('breadcrumb').scrollIntoView(true);
            }
        },
        goPrev() {
            this.page = this.page - 1;
            this.images = [];
            this.getAlbum(
                `${this.$route.params.category}/${this.$route.params.album}`,
            );
            document.getElementById('breadcrumb').scrollIntoView(true);
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/album/album.page.js